import { type RouteRecordRaw } from "vue-router";
import { ROUTE_NAME } from "@/shared/constants/routes";
import PaymentsLog from "./views/PaymentsLog.vue";

export const routes: RouteRecordRaw[] = [
  {
    path: "/payments/invoices",
    name: ROUTE_NAME.PAYMENT_INVOICES,
    meta: { requiresPayments: true },
    component: () => import("./views/InvoicesView.vue"),
  },
  {
    path: "/payments/invoices/create",
    name: ROUTE_NAME.CREATE_INVOICE,
    meta: { requiresPayments: true },
    component: () => import("./views/CreateInvoice.vue"),
  },
  {
    path: "/payments/invoices/:id",
    name: ROUTE_NAME.VIEW_INVOICE,
    meta: { requiresPayments: true },
    component: () => import("./views/ViewInvoice.vue"),
  },
  {
    path: "/payments/invoices/:id/edit",
    name: ROUTE_NAME.EDIT_INVOICE,
    meta: { requiresPayments: true },
    component: () => import("./views/EditInvoice.vue"),
  },
  {
    path: "/payments/log",
    name: ROUTE_NAME.PAYMENT_LOG,
    meta: { requiresPayments: true },
    component: PaymentsLog,
  },
  {
    path: "/payments/log/new",
    name: ROUTE_NAME.PAYMENT_LOG_NEW,
    meta: { requiresPayments: true },
    component: () => import("./views/NewTerminalPayment.vue"),
  },
];
